var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypeDrone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F3EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_32346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.953 19.518C17.8837 19.518 19.449 17.9446 19.449 16.0041C19.449 14.0636 17.8837 12.4903 15.953 12.4903C14.0224 12.4903 12.4571 14.0636 12.4571 16.0041C12.4571 17.9446 14.0224 19.518 15.953 19.518Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80204 13.3354C11.7327 13.3354 13.298 11.7621 13.298 9.82154C13.298 7.88103 11.7327 6.30769 9.80204 6.30769C7.87143 6.30769 6.30612 7.88103 6.30612 9.82154C6.30612 11.7621 7.87041 13.3354 9.80204 13.3354Z",
    stroke: "#12181E",
    strokeWidth: 0.612245,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1724 13.3354C24.1031 13.3354 25.6684 11.7621 25.6684 9.82154C25.6684 7.88103 24.1031 6.30769 22.1724 6.30769C20.2418 6.30769 18.6765 7.88103 18.6765 9.82154C18.6765 11.7621 20.2408 13.3354 22.1724 13.3354Z",
    stroke: "#12181E",
    strokeWidth: 0.612245,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80204 25.6923C11.7327 25.6923 13.298 24.119 13.298 22.1785C13.298 20.2379 11.7327 18.6646 9.80204 18.6646C7.87143 18.6646 6.30612 20.2379 6.30612 22.1785C6.30612 24.119 7.87041 25.6923 9.80204 25.6923Z",
    stroke: "#12181E",
    strokeWidth: 0.612245,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1724 25.6923C24.1031 25.6923 25.6684 24.119 25.6684 22.1785C25.6684 20.2379 24.1031 18.6646 22.1724 18.6646C20.2418 18.6646 18.6765 20.2379 18.6765 22.1785C18.6765 24.119 20.2408 25.6923 22.1724 25.6923Z",
    stroke: "#12181E",
    strokeWidth: 0.612245,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60716 10.0174C13.2041 13.6318 16.8021 17.2462 20.399 20.8605C20.9021 21.3662 21.4041 21.8708 21.9072 22.3764C22.1582 22.6287 22.548 22.2369 22.297 21.9846C18.7 18.3703 15.1021 14.7559 11.5051 11.1415C11.0021 10.6359 10.5 10.1313 9.99696 9.62564C9.74492 9.37333 9.35614 9.76512 9.60716 10.0174Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9071 9.62872C18.3102 13.2431 14.7122 16.8574 11.1153 20.4718C10.6122 20.9774 10.1102 21.4821 9.60714 21.9877C9.35612 22.24 9.74592 22.6318 9.99694 22.3795C13.5939 18.7651 17.1918 15.1508 20.7888 11.5364C21.2918 11.0308 21.7939 10.5262 22.2969 10.0205C22.548 9.76821 22.1582 9.37641 21.9071 9.62872Z",
    fill: "#12181E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_32346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypeDrone);
export default __webpack_public_path__ + "static/media/order_type_drone.441863a1a20ebed6ac67b7e96b15de41.svg";
export { ForwardRef as ReactComponent };